<template>
  <div style="display: flex; flex: 1;">
    <b-loading :active="isPageReady === false || isWaitingResponse === true"></b-loading>
    <template v-if="isPageReady === true && isWaitingResponse === false">
      <div id="register-step1" class="register-step">
        <div id="main-part">
          <div class="register-header register-header-margin">
            <a @click="prevStep">
              <span class="icon"> <i class="mdi mdi-arrow-left"></i> </span>
            </a>
            <h2>1/3 DATOS DE REGISTRO</h2>
            <div></div>
          </div>

          <div class="register-content">
            <p v-html="texts.register.step1.text1"></p>
            <div class="register-forms-container">
              <b-field :type="type_email" :message="msg_email">
                <b-icon class="onlyline-icon" pack="mdi" icon="email-outline" size="is-small">
                </b-icon>
                <b-input type="email" ref="emailField" class="onlyline" placeholder="email" v-model="mail" expanded
                  required>
                </b-input>
              </b-field>

              <b-field :type="type_password" :message="msg_password">
                <b-icon class="onlyline-icon" pack="mdi" icon="lock" size="is-small">
                </b-icon>
                <b-input type="password" ref="passwordField" class="onlyline" placeholder="password" v-model="pass"
                  expanded required password-reveal>
                </b-input>
              </b-field>

              <b-field :message="countrymsg" :type="countrytype">
                <b-icon class="onlyline-icon" pack="mdi" icon="map-marker" size="is-small">
                </b-icon>


                <b-select expanded v-model="selectedcountry" style="margin-left:9px;border-bottom: 1px solid;">
                  <option v-for="(oneCountry, index) in filteredCountriesArray" :value="oneCountry" :key="index">
                    {{ oneCountry.name }}
                  </option>
                </b-select>
              </b-field>


            </div>
            <div id="terms-container">
              <div class="field field-term" :type="componentTerm.type" v-for="(componentTerm, indx) in componentTerms"
                :key="componentTerm.term.nid">
                <b-checkbox type="is-success" @input="checkTerm(indx)" required v-model="componentTerm.accepted">
                </b-checkbox>
                <a class="view-terms" :class="componentTerm.type" @click="viewTerms(indx)">{{ componentTerm.term.title }}
                  <span class="icon">
                    <i class="mdi mdi-open-in-new"></i>
                  </span>
                </a>
              </div>
              <div class="field error-msg">
                <span v-if="showTermsError"> {{ checkboxErrorMsg }} </span>
              </div>
            </div>
          </div>
          <div class="register-button-container">
            <a class="button is-medium is-fullwidth is-primary" @click="nextStep">
              Continuar
            </a>
          </div>
        </div>
        <div id="belowbutton">
          <p class="interface-small-text has-text-grey-light"></p>
        </div>
      </div>
      <!-- fin register-step1 -->

      <b-modal :active.sync="isComponentModalActive" has-modal-card>
        <div class="modal-card">
          <section class="modal-card-body">
            <TermsText :htmltext="longText"> </TermsText>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-success" v-on:click="accept">
              Aceptar
            </button>
            <button class="button" v-on:click="closeModal">Cerrar</button>
          </footer>
        </div>
      </b-modal>
    </template>
  </div>
</template>
<script>
import TermsText from '../UI/TermsText.vue'
import { RegisterStepMixin } from '../mixins/RegisterStepMixin'
import { ToolsMixin } from '../mixins/ToolsMixin'
import types from '../../store/types'
export default {
  name: 'RegisterStep1',
  components: {
    TermsText
  },
  mixins: [RegisterStepMixin, ToolsMixin],
  data: function () {
    return {
      mail: '',
      pass: '',
      componentTerms: [],
      currentLongText: '',
      currentReadText: -1,
      isComponentModalActive: false,
      msg_email: '',
      type_email: '',
      msg_password: '',
      type_password: '',
      checkboxErrorMsg: 'Tienes que aceptar todos los términos y condiciones',
      triedToSubmit: false,

      isWaitingResponse: false,
      countrytype: '',
      countrymsg: '',
      countryname: '',
      selectedcountry: null,
      countries: [],
      openOnFocus: true,
      keepfirst: true,
    }
  },
  methods: {
    countrySelected(option) {
      this.selectedcountry = option
      if (option === null) this.countryname = ''
      else this.countryname = option.name
      this.validateCountryname()
    },
    validateCountryname() {
      var countryname2 = this.countryname.toLowerCase()
      var vv = this.countries.filter(element => {
        return (
          element.name
            .toString()
            .toLowerCase()
            .indexOf(countryname2) >= 0
        )
      })
      if (vv.length > 0) {
        this.countrymsg = ''
        this.countrytype = 'is-success'
        return true
      } else {
        this.countrymsg = 'Parece que no es un nombre de país apropiado'
        this.countrytype = 'is-danger'
        return false
      }
    },

    nextStep() {
      this.triedToSubmit = true
      if (this.ifFormValid() == false) return
      window._paq.push(['setCustomVariable', 1, 'email', this.mail, 'visit']) //TODO: REVISAR ESTO

      this.isWaitingResponse = true
      this.$store.commit('register/setStep0', {
        mail: this.mail,
        pass: this.pass,
        country: this.selectedcountry
      })
      if (this.allTermsChecked) {
        this.$store.commit('register/setAcceptedTerms')
      }
      //register with mail and passwd
      let globalTermsID = []
      this.componentTerms.forEach(t => {
        if (t.accepted) globalTermsID.push(t.term.nid)
      })
      this.$store.commit('register/setGlobalTermsID', {
        value: globalTermsID
      })
      this.$store
        .dispatch('register/checkMail', {
          mail: this.mail
        })
        .then(({ data }) => {
          if ('email_valid' in data) {
            if (data.email_valid === true) {
              this.$store.commit('register/nextStep')
              this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 2', 'Next')
            } else {
              this.type_email = 'is-danger'
              this.msg_email = `La dirección de correo ${this.mail} ya está registrada. ¿Ha olvidado su contraseña?`
            }
          }

          this.isWaitingResponse = false
        })
    },

    checkTerm(indx) {
      if (this.componentTerms[indx].accepted == false) {
        this.componentTerms[indx].type = 'is-danger'
        return false
      } else {
        this.componentTerms[indx].type = 'is-success'
        return true
      }
    },
    checkEmail() {
      if (this.$refs.emailField.checkHtml5Validity() == false) {
        this.type_email = 'is-danger'
        return false
      }
      if (this.$refs.emailField.checkHtml5Validity() == false) {
        this.type_email = 'is-danger'
        return false
      }
    },
    checkPasswd() {
      this.$refs.passwordField.checkHtml5Validity()
    },
    ifFormValid() {
      var isValid =
        this.$refs.emailField.checkHtml5Validity() &&
        this.$refs.passwordField.checkHtml5Validity() &&
        this.allTermsChecked
      return isValid
    },

    viewTerms(indx) {
      this.currentLongText = this.componentTerms[indx].term.body
      this.currentReadText = indx
      this.isComponentModalActive = true
    },
    closeModal() {
      this.isComponentModalActive = false
    },
    accept() {
      this.componentTerms[this.currentReadText].accepted = true
      this.closeModal()
    },
    buildComponentTerms() {
      if (this.componentTerms.length == 0) {
        this.$store.state.register.usefulTerms.forEach(t => {
          this.componentTerms.push({ term: t.term, accepted: false, type: '' })
        })
      }
    }
  },
  computed: {
    filteredCountriesArray() {
      return this.countries.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.countryname.toLowerCase()) >= 0
        )
      })
    },
    isPageReady: function () {
      if (
        this.$store.state.register.globalTermsDownloaded === true &&
        this.$store.state.register.productTermsDownloaded === types.QUERY_OK
      )
        return true
      else return false
    },
    longText: function () {
      return this.currentLongText
    },
    showTermsError: function () {
      if (this.triedToSubmit == false) return false
      let acceptedTerms = true
      this.componentTerms.forEach(t => {
        acceptedTerms = acceptedTerms && t.accepted
      })
      return !acceptedTerms
    },
    allTermsChecked: function () {
      let acceptedTerms = true
      this.componentTerms.forEach(t => {
        acceptedTerms = acceptedTerms && t.accepted
      })
      return acceptedTerms
    }
  },
  watch: {
    isPageReady: function (val) {
      console.log('is page ready watcher')
      if (val === true) {
        this.buildComponentTerms()
      }
    },
    countries: function () {
      let findCountry = this.countries.find(one =>
        one.id === "ES")
      this.selectedcountry = findCountry
    }
  },
  created() {
    this.$store.dispatch('register/getProductTerms')
    this.$store.dispatch('register/getGlobalTerms')
    if (this.isPageReady) {
      this.buildComponentTerms()
    }
    this.isLoading = true
    // eslint-disable-next-line
    this.$store
      .dispatch('register/getCountries')
      .then(() => {
        this.isLoading = false
        this.countries = this.$store.state.register.countries
      })

  }
}
</script>
<style lang="less">
//@import (reference) '../../assets/styles/main.less';
#register-step1 {
  div.modal-background {
    background-color: rgba(255, 255, 255, 0.99);
  }

  button.modal-close:before,
  button.modal-close:after {
    background-color: #0ac6d3;
  }

  .register-forms-container {}

  .register-button-container {
    margin-top: 2rem;
  }

  #terms-container {
    text-align: left;
    margin-top: 4em;
  }

  .field-term {
    display: flex;
    margin-top: 16px;
  }

  a.view-terms {
    font-style: normal;
    font-weight: 300;
    line-height: 16px;
    font-size: 13px;
    /*text-decoration-line: underline;
  color: rgba(0, 0, 0, 0.6); */
  }

  select {
    border: none;
    padding: 7px 40px 7px 0px;
  }

  select:active,
  select:focus {
    border: none;
    box-shadow: none;
  }

  .select:not(.is-multiple):not(.is-loading)::after {
    border-color: #0AC6D3 !important;
    right: 14px;
  }

}
</style>
